"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.levels = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var levels = {
  1: {
    label: 'Beginner',
    color: 'green'
  },
  2: {
    label: 'Intermediate',
    color: 'orange'
  },
  3: {
    label: 'Advanced',
    color: 'red'
  }
};
exports.levels = levels;

var LevelIndicator = /*#__PURE__*/function (_React$Component) {
  _inherits(LevelIndicator, _React$Component);

  var _super = _createSuper(LevelIndicator);

  function LevelIndicator() {
    _classCallCheck(this, LevelIndicator);

    return _super.apply(this, arguments);
  }

  _createClass(LevelIndicator, [{
    key: "render",
    value: function render() {
      var props = this.props; // // Get supplies in order for constructing the difficulty level bits

      var levelColor = levels[props.level].color;
      var levelLabel = levels[props.level].label; // Make the "difficulty level" squares

      var levelSquares = Object.keys(levels).map(function (level) {
        var squareColor = level > props.level ? "".concat(levelColor, "-light") : levelColor;
        return /*#__PURE__*/_react.default.createElement("div", {
          key: level,
          style: {
            height: '8px',
            borderRadius: '1px'
          },
          className: "inline-block w6 bg-".concat(squareColor, " align-middle mr3")
        });
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "dr-ui--level-indicator flex-parent flex-parent--center-cross"
      }, levelSquares, /*#__PURE__*/_react.default.createElement("div", {
        className: "inline-block color-gray ml3"
      }, levelLabel));
    }
  }]);

  return LevelIndicator;
}(_react.default.Component);

LevelIndicator.propTypes = {
  level: _propTypes.default.oneOf([1, 2, 3]).isRequired
};
var _default = LevelIndicator;
exports.default = _default;